import { useCallback, useEffect, useRef } from 'react';
import { findNodeHandle, NativeEventEmitter, NativeModules, Platform } from 'react-native';

export default function useMacModalFocus(ref, active, onClose, returnRef) {
  const registered = useRef(null);
  const close = useRef(onClose); close.current = onClose;
  const sync = useCallback(() => {
    if (Platform.OS !== 'macos' || !active) return;
    const tag = findNodeHandle(ref.current);
    if (tag == null) return;
    if (registered.current != null && registered.current !== tag) {
      NativeModules.MacMenuBridge?.setModalFocusScope?.(registered.current, false);
    }
    registered.current = tag;
    const bridge = NativeModules.MacMenuBridge;
    const returnTag = returnRef?.current ? findNodeHandle(returnRef.current) : null;
    if (returnTag != null && bridge?.setModalFocusScopeWithReturnView) {
      bridge.setModalFocusScopeWithReturnView(tag, returnTag);
    } else {
      bridge?.setModalFocusScope?.(tag, true);
    }
  }, [ref, active, returnRef]);
  useEffect(() => {
    sync();
    return () => {
      if (registered.current != null) NativeModules.MacMenuBridge?.setModalFocusScope?.(registered.current, false);
      registered.current = null;
    };
  }, [sync]);
  useEffect(() => {
    const bridge = NativeModules.MacMenuBridge;
    if (Platform.OS !== 'macos' || !active || !bridge?.setModalFocusScope) return;
    const listener = new NativeEventEmitter(bridge).addListener('onModalDismiss', event => {
      if (event.tag === registered.current) close.current?.();
    });
    return () => listener.remove();
  }, [active]);
  return sync;
}
